import { LaunchRounded, PictureAsPdf, AddCircle, Create, AccountCircle } from "@material-ui/icons";

export const PublicNav = [
	// The Services dropdown (Lettings/Sales brochure PDFs, Instant
	// Valuation, 360 Management, Refurbishment, Cleaning) was replaced here
	// by two direct links to the in-app guide pages - the guides themselves
	// link out to Instant Valuation, and cover 360 Management as one of the
	// lettings fee tiers. The same dropdown lives on unchanged in
	// FooterNav below, so Refurbishment/Cleaning/the PDFs are still
	// reachable from the footer.
	//
	// About Us, Testimonials, Meet The Team and Blog were dropped from the
	// header to make room for a larger logo; all four stay in FooterNav's
	// About Us column, and all are in sitemap.xml. The nav and footer are
	// both client-rendered (api/render.js serves no nav links either way), so
	// crawlers that run JavaScript see the footer links just as they did these.
	{ title: "Lettings", link: "/lettings-guide" },
	{ title: "Sales", link: "/sales-guide" },
	{ title: "Management", link: "/management-guide" },
	{ title: "Price List", link: "/pricelist" },
	{ title: "Contact", link: "/contact" },
];

export const FooterNav = [
	{
		title: "Services",
		link: "/",
		target: "_self",
		submenu: [
			{
				title: "Lettings",
				link: "/lettings-guide",
				target: "_self",
			},
			{
				title: "Sales",
				link: "/sales-guide",
				target: "_self",
			},
			{
				title: "INSTANT VALUATION",
				link: "https://www.onthemarket.com/instant-valuation/property-people",
				icon: <PictureAsPdf />,
				target: "_blank",
				external: true,
			},
			{
				title: "360 Management",
				link: "/management-guide",
				target: "_self",
			},
			{
				title: "Refurbishment",
				link: "https://property-people.net",
				icon: <LaunchRounded />,
				target: "_blank",
				external: true,
			},
			{
				title: "Cleaning",
				link: "https://swcarpetcleaning.co.uk",
				icon: <LaunchRounded />,
				target: "_blank",
				external: true,
			},
			{
				title: "Price List",
				link: "/pricelist",
				target: "_self",
			},
			{
				title: "Your property public data",
				link: "/property-report",
				target: "_self",
			},
			{
				// The index of the district pages. They are reachable from
				// here and from each other and from nowhere else, so without
				// this link all 81 of them are orphans.
				title: "House prices by postcode",
				link: "/house-prices",
				target: "_self",
			},
		],
	},
	{
		title: "About Us",
		link: "/about-us",
		target: "_self",
		submenu: [
			{ title: "Blog", link: "/blog", target: "_self" },
			{ title: "Testimonials", link: "/testimonials", target: "_self" },
			{ title: "Meet the team", link: "/meet-the-team", target: "_self" },
			{ title: "Contact", link: "/contact", target: "_self" },
			{ title: "Privacy Policy", link: "/privacy-policy", target: "_self" },
			{
				title: "Complaints Procedure",
				link: "https://property-people.co.uk/legal/TPO_In_House_Complaints_Procedure.pdf",
				target: "_blank",
			},
			{
				title: "Client Money Protection Certificate",
				link: "/client-money-protection",
				target: "_self",
			},
			{
				title: "PropertyMark Membership Rules and Conduct",
				link: "https://www.propertymark.co.uk/professional-standards/rules.html",
				target: "_blank",
			},
			{
				title: "May 1st 2026 Renters' Rights Survival Guide",
				link: "/offers/1may2026survivalguide.pdf",
				target: "_blank"
			}
		],
	},
];

export const AdminNav = [
	{ title: "Dashboard", link: "/dashboard" },
	{ title: "New Property", link: "/dashboard/create-property", icon: <AddCircle /> },
	{ title: "New Blog Article", link: "/dashboard/create-post", icon: <Create /> },
	{ title: "New Team Member", link: "/dashboard/create-team-member", icon: <AccountCircle /> },
];
